<template>
  <header class="entity__header">
    <ETitles :title="title" :subtitle="subtitle" data-test-id="entity-titles" />
    <!-- TODO: repeated from results/add-ons/thumbnail.vue,
      see if it can be consolidated -->
    <a
      v-if="image && image.thumbnailUrl"
      :href="imageUrl"
      class="entity__image"
      data-test-id="entity-thumbnail-link"
      @click="$emit('image-click')"
    >
      <EThumbnail
        :src="image.thumbnailUrl"
        :alt="image.title"
        data-test-id="entity-thumbnail-image"
      />
    </a>
  </header>
</template>
<script>
import EThumbnail from '~~/common/vue/components/thumbnail';
import ETitles from './titles';

export default {
  name: 'EBaseHeader',
  components: {
    EThumbnail,
    ETitles,
  },
  props: {
    title: ETitles.props.title,
    subtitle: ETitles.props.subtitle,
    imageUrl: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.entity__header {
  display: flex;
  justify-content: space-between;
  padding: $entity-base-vertical-padding $entity-base-horizontal-padding 0;

  @include desktop {
    padding: $entity-desktop-padding $entity-desktop-padding 0;
  }
}

.entity__image {
  flex-shrink: 0;
  width: $entity-image-base-size;
  height: $entity-image-base-size;
  margin-left: $space-s;
  background-color: var(--color-background-secondary);
  border-radius: $border-radius-l;
  transition: box-shadow $timing-2s $easing;
  will-change: box-shadow;
  overflow: hidden;
}
</style>
